import http from '../../services/http'

const state = {
    machines: [],
    extruders: [],
    compressionMolds: [],
    injectionMoulds: [],
    corrugator: [],
    //NEW DATA MANAGEMENT
    blewData: [],
    machines: [],
    mergedMachines: []
    //END NEW DATA MANAGEMENT
};

const getters = { 
    machinesList: state => state.machines
};

const actions = { 
    //FETCH MACHINES 
    async fetchmachines({commit}){
       const res = await http.get('/api/machines')
        const allMachines = res.data
        commit("setMachines", res.data)        
        commit('setExtruder', allMachines.filter(machine => machine.type == "Extruder"))
        commit('setCompressionMolds', allMachines.filter(machine => machine.type == "Compression Mould"))
        commit('setInjectionMoulds', allMachines.filter(machine => machine.type == "Injection Mould"))
        commit('setCorrugator', allMachines.filter(machine => machine.type == "Corrugator"))
    }
};
const mutations = { 
    setMachines: (state, machines) => (
        state.machines = machines
    ),
    setDailyMachineData: (state, dailyMachineData) => (
        state.dailyMachineData = dailyMachineData
    ),
    setExtruder: (state, extruders) => (
        state.extruders = extruders
    ),
    setCompressionMolds: (state, compressionMolds) => (
        state.compressionMolds = compressionMolds
    ),
    setInjectionMoulds: (state, injectionMoulds) => (
        state.injectionMoulds = injectionMoulds
    ),
    setCorrugator: (state, corrugator) => (
        state.corrugator = corrugator
    ),

    //NEW DATA MANAGEMENT
    setBlewData(state, data) {
        state.blewData = data;
    },
    setMachines(state, data) {
        state.machines = data;
    },
    setMergedMachines(state, data) {
        state.mergedMachines = data;
    }
    //END NEW DATA MANAGEMENT

};

export default {
    state,
    getters,
    actions,
    mutations
}